import './dkt-loader.scss'

type DktLoaderProps = {
  variant?: 'dkt-blue' | 'black' | 'white'
  width: number
}

const DktLoader = ({ variant = 'dkt-blue', width }: DktLoaderProps) => {
  return (
    <div className={`dkt-loader ${variant}`} style={{ width: `${width}px` }} />
  )
}

export default DktLoader
